module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ar":{"new_vendor":"تسجيل مزود جديد","calc_vat":"حساب ض.ق.م.","no_vat":"لا تحسب ض.ق.م."},"he":{"new_vendor":"تسجيل مزود جديد"}}')
  delete Component.options._Ctor
}
